export const languagesList = {
  english: "en-US", // English (United States)
  urdu: "ur-PK", // Urdu (Not supported in your browser TTS)
  bengali: "bn", // Bengali (Not supported in your browser TTS)
  chinese: "zh-CN", // Chinese (Simplified)
  spanish: "es-ES", // Spanish (Spain)
  french: "fr-FR", // French (France)
  indonesian: "id-ID", // Indonesian
  russian: "ru-RU", // Russian
  swedish: "sv-SE", // Swedish (Not supported in your browser TTS)
  turkish: "tr-TR", // Turkish (Not supported in your browser TTS)
  hindi: "hi-IN", // Hindi
  italian: "it-IT", // Italian
  japanese: "ja-JP", // Japanese
  korean: "ko-KR", // Korean
  dutch: "nl-NL", // Dutch
  polish: "pl-PL", // Polish
  portuguese: "pt-BR", // Portuguese (Brazil)
  cantonese: "zh-HK", // Cantonese (Hong Kong)
  taiwanese: "zh-TW", // Mandarin (Taiwan)
};

export const languagesData = {
  english: {
    code: "en-US",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_en.json",
    translator: "Umm Muhammad (Saheeh International)",
    webSource: "Saheeh International Translation",
  },
  urdu: {
    code: "ur-PK",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_ur.json",
    translator: "Abul A'la Maududi",
    webSource: "Abul A'la Maududi Translation",
  },
  bengali: {
    code: "bn",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_bn.json",
    translator: "Muhiuddin Khan",
    webSource: "Muhiuddin Khan Translation",
  },
  chinese: {
    code: "zh-CN",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_zh.json",
    translator: "Muhammad Makin",
    webSource: "Muhammad Makin Translation",
  },
  spanish: {
    code: "es-ES",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_es.json",
    translator: "Muhammad Isa García",
    webSource: "Muhammad Isa García Translation",
  },
  french: {
    code: "fr-FR",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_fr.json",
    translator: "Muhammad Hamidullah",
    webSource: "Muhammad Hamidullah Translation",
  },
  indonesian: {
    code: "id-ID",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_id.json",
    translator: "Indonesian Ministry of Religious Affairs",
    webSource: "Indonesian Translation",
  },
  russian: {
    code: "ru-RU",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_ru.json",
    translator: "Elmir Kuliev",
    webSource: "Elmir Kuliev Translation",
  },
  swedish: {
    code: "sv-SE",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_sv.json",
    translator: "Knut Bernström",
    webSource: "Knut Bernström Translation",
  },
  turkish: {
    code: "tr-TR",
    jsonUrl: "https://cdn.jsdelivr.net/npm/quran-json@3.1.2/dist/quran_tr.json",
    translator: "Turkish Directorate of Religious Affairs",
    webSource: "Turkish Translation",
  },
};
